"use client";
import dynamic from "next/dynamic";
import styles from "./styles.module.scss";

const SocialMediaSection = dynamic(
  () => import("../SocialMediaSection/SocialMediaSection"),
  { ssr: false },
);

export default function TagsAndSocialMediaSection({
  heading = {},
  date = {},
}) {
  return (
    <div className={styles.container}>
      {/* Tags section removed, reference - AM-1074 */}
      <SocialMediaSection date={date} heading={heading} />
    </div>
  );
}
